import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import Loading from '@/components/common/atoms/Loading';

import styles from './Button.module.css';

const sizeTheme = {
  'Small': {
    'padding': '0.33rem 0.66rem',
    'font-size': 0.75,
    'line-height': '1.5',
    'border-radius': '3px',
    'icon-size': 'lg'
  },
  'Long': {
    'padding': '0.55rem 3.14rem',
    'font-size': '1.2',
    'line-height': '1.3333',
    'border-radius': '6px',
    'icon-size': 'lg',
  },
  'SM': {
    'padding': '0.42rem 0.85rem',
    'font-size': '0.9rem',
    'line-height': '1.428',
    'border-radius': '3px',
    'icon-size': 'lg'
  }
};

const colorTheme = {
  'Yellow': {
    'color': '#fff',
    'bgColor': '#ffcc00',
    'bdColor': '#ffcc00',
    'hoverBg': '#ec971f',
    'hoverColor': '#fff',
    'hoverBd': '#d58512'
  },
  'Blue': {
    'color': '#fff',
    'bgColor': '#546995',
    'bdColor': '#546995',
    'hoverBg': '#3d4b67',
    'hoverColor': '#fff',
    'hoverBd': '#3d4b67'
  },
  'White': {
    'color': '#333',
    'bgColor': '#fff',
    'bdColor': '#ccc',
    'hoverBg': '#e6e6e6',
    'hoverColor': '#333',
    'hoverBd': '#adadad'
  },
  'Green': {
    'color': '#fff',
    'bgColor': '#27d2b8',
    'bdColor': '#27d2b8',
    'hoverBg': '#2fad9a',
    'hoverColor': '#fff',
    'hoberBd': '#2fad9a'
  },
  'Grey': {
    'color': '#fff',
    'bgColor': '#6c757d',
    'bdColor': '#6c757d',
    'hoverBg': '#5a6268',
    'hoverColor': '#fff',
    'hoberBd': '#5a6268'
  },
  'Red': {
    'color': '#fff',
    'bgColor': '#d9534f',
    'bdColor': '#d43f3a',
    'hoverBg': '#c9302c',
    'hoverColor': '#fff',
    'hoverBd': '#ac2925'
  }
};

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: ${ props => sizeTheme[props.size]['line-height'] };
  border-radius: ${ props => sizeTheme[props.size]['border-radius']};
  margin: ${ props => props.margin };
  margin-bottom: 0;
  padding: ${props => sizeTheme[props.size]['padding']};
  font-size: ${props => sizeTheme[props.size]['font-size'] + 'rem'};
  font-weight: normal;
  background: ${props => colorTheme[props.color]['bgColor']};
  color: ${props => colorTheme[props.color]['color']};
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  border-color: ${props => colorTheme[props.color]['bdColor']};
  white-space: nowrap;
  height: ${props => props.height};
  width: ${props => props.width};
  &:hover {
    background: ${props => colorTheme[props.color]['hoverBg']};
    color: ${props => colorTheme[props.color]['hoverColor']};
    border-color: ${props => colorTheme[props.color]['hoverBd']};
  }

  a {
    color: inherit; /* 使用 button 的文字顏色 */
    text-decoration: none; /* 移除下劃線 */
    &:hover {
      text-decoration: underline; /* 可選：設定 hover 效果 */
    }
  }
`;

StyledButton.defaultProps = {
  type: 'submit',
  arrowLeft: false,
  arrow: false,
  plus: false,
  width: 'auto'
};


const ButtonWrap = ({ href, className, children }) => {
  return href ? (
    <Link to={ href } className={ cx(styles.ButtonWrap, className) }>
      { children }
    </Link>
  ) : (
    <div className={ cx(styles.Link, styles.ButtonWrap, className) }>
      { children }
    </div>
  );
};

const Button = props => {
  const {
    text, leftArrow, arrow, plus, size, color, href, isLoading,
    type, onClick  // for pass to StyledButton
  } = props;

  return (
    <StyledButton { ...props }>
      <>
        <Loading
          size="xs" padding="0"
          className={ cx(styles.Loader, { [styles.Hidden]: !isLoading }) }
        />
        <ButtonWrap href={ href } className={ cx({ [styles.Hidden]: isLoading }) }>
          { leftArrow ?
            <FontAwesomeIcon
              icon={ fas.faAngleLeft }
              size={ sizeTheme[size]['icon-size'] }
              style={{
                color: colorTheme[color]['color'],
                marginRight: '0.25rem',
              }}
            />
            :
              null
          }
          { text }
          { arrow ?
            <FontAwesomeIcon
              icon={ fas.faAngleRight }
              size={ sizeTheme[size]['icon-size'] }
              style={{
                color: colorTheme[color]['color'],
                marginLeft: '0.25rem',
              }}
            />
            :
              null
          }
          { plus ?
            <FontAwesomeIcon
              icon={ fas.faPlus }
              size={ sizeTheme[size]['icon-size'] }
              style={{
                color: colorTheme[color]['color'],
                marginLeft: '0.25rem',
              }}
            />
            :
              null
          }
        </ButtonWrap>
      </>
    </StyledButton>
  );
};

Button.defaultProps = {
  color: 'White',
  size: 'Long',
  isLoading: false
};

export default Button;
